import { render, staticRenderFns } from "./FailReason.vue?vue&type=template&id=00b443af&scoped=true&"
import script from "./FailReason.vue?vue&type=script&lang=ts&"
export * from "./FailReason.vue?vue&type=script&lang=ts&"
import style0 from "./FailReason.vue?vue&type=style&index=0&id=00b443af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b443af",
  null
  
)

export default component.exports